import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import signOutIcon from "../../assets/icons/sign-out.svg";
import { routeNames } from "../../routes";
import "./Footer.sass";

const Footer = ({ signOut, isLoggedIn }) => {
  return (
    <footer className="footer">
      <div className="links">
        <Link to={routeNames.about}>About the Project</Link>
        <Link to={routeNames.resources}>Resources</Link>
        <Link to={routeNames.partners}>Partners</Link>
        <Link to={routeNames.funding}>Funding</Link>
        <Link to={routeNames.contact}>Contact</Link>
        {/* <Link to={routeNames.privacyPolicy}>Privacy Policy</Link> */}
        {isLoggedIn && (
          <button onClick={signOut}>
            <img src={signOutIcon} alt="sign out" />
            Sign Out
          </button>
        )}
      </div>
    </footer>
  );
};

Footer.propTypes = {
  signOut: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool,
};

export default Footer;
